module.exports = __webpack_public_path__ + "img/stage_spitzwegerich.e490d25f.jpg";